// extracted by mini-css-extract-plugin
export default {"alert":"style_alert__pWZ9w"};